import React from 'react';
import { Alert, Select, Spin, Upload } from 'antd';

import { FILE_CSV } from '../icons';
import { ACCEPT_ATTRIBUTE, MAX_ROWS, sheetProblem } from '../../utils/spreadsheet/readFile';
import { countWords } from './importCopy';

const sheetLabel = sheet => `${sheet.name} · ${countWords(sheet.rows.length, 'row')}`;

/**
 * Step 1: the card, then the file. `cardPicker` is the page's (a bundle's setup
 * step has its card already, and passes nothing). The file is read here in the
 * browser; a workbook with several sheets asks which, and one with a single
 * sheet moves straight on.
 */
export default function ChooseFileStep({ cardPicker = null, card, book, sheetIndex, reading, error, onFile, onSheet }) {
	const sheet = book?.sheets[sheetIndex] || null;
	const problem = sheet ? sheetProblem(sheet) : null;
	return (
		<section className="spreadsheet-import__panel" aria-label="Choose a file">
			{cardPicker}
			<Upload.Dragger
				className="spreadsheet-import__drop"
				accept={ACCEPT_ATTRIBUTE}
				multiple={false}
				showUploadList={false}
				disabled={!card || reading}
				beforeUpload={file => { onFile(file); return false; }}
			>
				<span className="spreadsheet-import__drop-icon"><FILE_CSV aria-hidden="true" /></span>
				<p className="spreadsheet-import__drop-title">
					{reading ? <><Spin size="small" /> Reading the file</> : 'Drop a CSV or XLSX file here, or press to choose one'}
				</p>
				<p className="spreadsheet-import__note">
					{`A row of column names, then a row for each record. Up to ${MAX_ROWS.toLocaleString('en-US')} rows at a time.`}
				</p>
			</Upload.Dragger>
			<p className="spreadsheet-import__note">
				The file stays in this browser. keepr receives only the values you choose to import.
			</p>
			{error ? <Alert type="error" showIcon message={error} /> : null}
			{book && book.sheets.length > 1 ? (
				<label className="spreadsheet-import__field">
					<span className="micro-label">Sheet</span>
					<Select
						value={sheetIndex}
						onChange={onSheet}
						options={book.sheets.map((entry, index) => ({ value: index, label: sheetLabel(entry) }))}
						aria-label="The sheet to import"
					/>
				</label>
			) : null}
			{book && !error ? (
				<p className="spreadsheet-import__file">
					{book.fileName}
					{sheet && !problem ? ` · ${countWords(sheet.rows.length, 'row')} · ${countWords(sheet.columns.length, 'column')}` : ''}
				</p>
			) : null}
			{problem ? <Alert type="error" showIcon message={problem} /> : null}
		</section>
	);
}
